/**
 * Main application script
 * - Dynamic year in footer
 * - Equal-height card headings
 * - Blog category dropdown toggle
 * - Blog slider (Swiper) initialization
 */

let resizeTimer;
let resizeTitle;

// ── Hoisted to global scope so resize/load handlers can access them ──
let productTitle;
let productGrid;
let desktopHeader;
let productInfoList;

function moveProductTitle() {
  if (!productTitle || !productGrid || !desktopHeader) return;

  if (window.innerWidth <= 749) {
    // Mobile: move title above .product-information__grid
    if (productGrid.previousElementSibling !== productTitle) {
      productGrid.parentNode.insertBefore(productTitle, productGrid);
    }
  } else {
    // Desktop: restore title
    if (!desktopHeader.contains(productTitle)) {
      if (productInfoList) {
        desktopHeader.insertBefore(productTitle, productInfoList);
      } else {
        desktopHeader.appendChild(productTitle);
      }
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {

  /* ── 1. Current year update ────────────────────────────────── */
  const yearEls = document.querySelectorAll("footer rte-formatter .highlight_text--content");
  const year = new Date().getFullYear();
  yearEls.forEach(function (el) {
    el.textContent = year;
  });

  // ── 2. Equal heights (debounced) ────────────────────────────
  resizeTimer = setTimeout(runEqualHeights, 360);

  // ── 3. Blog category dropdown toggle ────────────────────────
  initCategoryDropdowns();

  // ── 4. Blog slider (Swiper) via MutationObserver ────────────
  initBlogSliderObserver();

  runEqualHeights();

  // const recentlyViewed = document.querySelector(".recently-viewed__wrapper");
  // if (!recentlyViewed) return;
  // const observer = new MutationObserver(function () {
  //   setTimeout(function () {
  //     runEqualHeights();
  //   }, 300);
  // });
  // observer.observe(recentlyViewed, {
  //   childList: true,
  //   subtree: true
  // });

  document.addEventListener("DOMContentLoaded", function () {
  const dynamicSections = document.querySelectorAll(
    ".recently-viewed__wrapper, .collection-carousel-swiper-component"
  );
  if (!dynamicSections.length) return;
  dynamicSections.forEach(function (section) {
    const observer = new MutationObserver(function (mutations) {
      let hasChanges = false;
      mutations.forEach(function (mutation) {
        if (mutation.addedNodes.length > 0) {
          hasChanges = true;
        }
      });
      if (hasChanges) {
        setTimeout(function () {
          runEqualHeights();
        }, 500);
      }
    });
    observer.observe(section, {
      childList: true,
      subtree: true
    });
  });
});

/**
 * Responsive Product Title Position
 *
 * <= 749px:
 *   .cst-product-title -> above .product-information__grid
 *
 * >= 750px:
 *   .cst-product-title -> .cst-product-dt-header
 *   positioned before .product-info-list
 */

  productTitle = document.querySelector(".cst-product-title");
  productGrid = document.querySelector(".product-information__grid");
  desktopHeader = document.querySelector(".cst-product-dt-header");
  productInfoList = document.querySelector("product-info-list");

  if (!productTitle || !productGrid || !desktopHeader) {
    return;
  }

  // Initial position
  moveProductTitle();
});

// ── Resize handler ────────────────────────────────────────────
window.addEventListener("resize", function () {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(runEqualHeights, 360);

  clearTimeout(resizeTitle);
    resizeTitle = setTimeout(function () {
      moveProductTitle();
    }, 150);
});

window.addEventListener("load", function () {
  setTimeout(function () {
    if (
      document.querySelector(".recently-viewed__wrapper") ||
      document.querySelector(".collection-carousel-swiper-component")
    ) {
      runEqualHeights();
    }
  }, 1000);
   moveProductTitle();
});

// ── Grid-view button re-calc ──────────────────────────────────
document.addEventListener("click", function (e) {
  if (
    e.target.closest(".button--grid-view") ||
    e.target.closest(".cst-collection-filter-sidebar") ||
    e.target.closest(".blog-post__category-list-link") ||
    e.target.closest("[role*='button']")
  ) {
    setTimeout(runEqualHeights, 350);
  }
});

document.addEventListener("change", function (e) {
  if (e.target.matches(".list-menu__item input[type='checkbox']")) {
    setTimeout(runEqualHeights, 350);
  }
});



// ── Equal-height logic ────────────────────────────────────────
function runEqualHeights() {
  equalHeight(".card__heading .text");  
  equalHeight(".swiper .card__heading .text");
  equalHeight(".blog-post__sidebar-products .card__heading .text");
  equalHeight(".recently-viewed-products .card__heading .text");
  equalHeight(".cst-product-sec .swiper-wrapper .grid__item.swiper-slide");
  equalHeight(".product-recommendations .swiper-wrapper .grid__item.swiper-slide");
 
}

// ── Re-run equal heights when new products are loaded dynamically ──
window.addEventListener("DOMContentLoaded", function () {
  const productContainer =
    document.querySelector(".collection") ||
    document.querySelector(".productGrid") ||
    document.querySelector(".product-grid") ||
    document.querySelector("#product-grid");

  if (!productContainer) return;

  let timer;

  const observer = new MutationObserver(function (mutations) {
    let hasNewProducts = false;

    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length > 0) {
        hasNewProducts = true;
      }
    });

    if (hasNewProducts) {
      clearTimeout(timer);
      timer = setTimeout(function () {
        runEqualHeights();
      }, 300);
    }
  });

  observer.observe(productContainer, {
    childList: true,
    subtree: true
  });
});

function equalHeight(selector) {
  const elements = document.querySelectorAll(selector);
  if (!elements.length) return;

  // Reset all heights first
  elements.forEach(function (el) {
    el.style.height = "auto";
  });

  let currentTallest = 0;
  let currentRowStart = 0;
  let rowDivs = [];

  elements.forEach(function (el) {
    const topPosition = el.offsetTop;

    if (currentRowStart !== topPosition) {
      // Apply height to the *previous* row
      applyHeight(rowDivs, currentTallest);

      // Start a new row
      rowDivs = [];
      currentRowStart = topPosition;
      currentTallest = 0;
    }

    rowDivs.push(el);
    currentTallest = Math.max(currentTallest, el.offsetHeight);
  });

  // Apply height to the *last* row (was missing before)
  applyHeight(rowDivs, currentTallest);
}

function applyHeight(els, height) {
  els.forEach(function (el) {
    el.style.height = height + "px";
  });
}

// ── Slide-toggle utility ──────────────────────────────────────
function slideToggle(el, show, duration) {
  duration = duration || 300;

  if (show) {
    el.style.display = "block";
    var h = el.scrollHeight;
    el.style.height = "0px";
    el.style.overflow = "hidden";
    el.offsetHeight; // force reflow
    el.style.transition = "height " + duration + "ms ease";
    el.style.height = h + "px";
  } else {
    el.style.height = el.offsetHeight + "px";
    el.style.overflow = "hidden";
    el.offsetHeight; // force reflow
    el.style.transition = "height " + duration + "ms ease";
    el.style.height = "0px";
  }

  setTimeout(function () {
    if (!show) el.style.display = "none";
    el.style.removeProperty("height");
    el.style.removeProperty("overflow");
    el.style.removeProperty("transition");
  }, duration);
}

// ── Category dropdowns ────────────────────────────────────────
function initCategoryDropdowns() {
  document.querySelectorAll(".blog-post__category .icon-dropdown").forEach(function (toggle) {
    toggle.addEventListener("click", function (e) {
      e.preventDefault();

      var current = toggle.closest("li");
      if (!current) return;

      var submenu = current.querySelector(":scope > .dropdown-category-list");
      if (!submenu) return;

      // Close sibling dropdowns
      var siblings = current.parentElement.querySelectorAll(":scope > li.is-clicked");
      siblings.forEach(function (item) {
        if (item !== current) {
          item.classList.remove("is-clicked");
          var sub = item.querySelector(":scope > .dropdown-category-list");
          if (sub) slideToggle(sub, false);
        }
      });

      var opening = current.classList.toggle("is-clicked");
      slideToggle(submenu, opening);
    });
  });
}

// ── Blog Swiper slider (mobile/tablet only, < 992px) ─────────
var blogSwiper = null;
var blogSwiperPagination = null;
var BLOG_BREAKPOINT = 992;

function initBlogSliderObserver() {
  var section = document.querySelector(".cst-blog-app-section");
  if (!section) return;

  var observer = new MutationObserver(function () {
    if (document.querySelector(".cst-blog-app-section .blog-articles")) {
      handleBlogSlider();
      observer.disconnect();
    }
  });

  observer.observe(section, { childList: true, subtree: true });

  // Listen for resize to toggle slider on/off
  var sliderResizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(sliderResizeTimer);
    sliderResizeTimer = setTimeout(handleBlogSlider, 300);
  });
}

function handleBlogSlider() {
  if (window.innerWidth < BLOG_BREAKPOINT) {
    initBlogSlider();
  } else {
    destroyBlogSlider();
  }
}

function initBlogSlider() {
  var container = document.querySelector(".cst-blog-app-section .blog-articles");
  if (!container) return;

  // Already initialized — skip
  if (blogSwiper) return;

  container.classList.add("swiper");

  var wrapper = document.createElement("div");
  wrapper.className = "swiper-wrapper";

  // Move children into swiper-wrapper
  Array.from(container.children).forEach(function (item) {
    if (item.classList.contains("swiper-wrapper")) return;
    item.classList.add("swiper-slide");
    wrapper.appendChild(item);
  });

  container.appendChild(wrapper);

  // Create pagination
  blogSwiperPagination = document.createElement("div");
  blogSwiperPagination.className = "swiper-pagination";
  container.after(blogSwiperPagination);

  blogSwiper = new Swiper(container, {
    slidesPerView: 1,
    spaceBetween: 20,
    speed: 600,
    loop: true,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false
    },
    pagination: {
      el: blogSwiperPagination,
      clickable: true
    },
    breakpoints: {
      750: { slidesPerView: 2 }
    }
  });
}

function destroyBlogSlider() {
  if (!blogSwiper) return;

  var container = document.querySelector(".cst-blog-app-section .blog-articles");
  if (!container) return;

  // Destroy the Swiper instance
  blogSwiper.destroy(true, true);
  blogSwiper = null;

  // Remove pagination element
  if (blogSwiperPagination && blogSwiperPagination.parentNode) {
    blogSwiperPagination.parentNode.removeChild(blogSwiperPagination);
    blogSwiperPagination = null;
  }

  // Unwrap slides from swiper-wrapper back into the container
  var wrapper = container.querySelector(".swiper-wrapper");
  if (wrapper) {
    while (wrapper.firstChild) {
      var slide = wrapper.firstChild;
      slide.classList.remove("swiper-slide");
      container.appendChild(slide);
    }
    container.removeChild(wrapper);
  }

  // Remove swiper-related classes from container
  container.classList.remove("swiper", "swiper-initialized", "swiper-horizontal",
    "swiper-backface-hidden");
  container.removeAttribute("style");
}